<div *ngFor="let result of highestResults(); let last = last"
     class="psy-test-highest-results-transcript"
     [class.psy-test-highest-results-transcript_last]="result == last">
  <div class="psy-test-highest-results-transcript__key text text_bold text_big">
    {{ result.key }}
  </div>
  <app-multi-line-text [text]="result.transcript"></app-multi-line-text>
</div>
